import { Trans } from "@lingui/react/macro";
import { useState } from "react";

import { Button } from "../../../components/ui-kit/button";
import { Dialog } from "../../../components/ui-kit/dialog";
import { NumberInput } from "../../../components/ui-kit/fields/number-input";

export function ManualValueOverrideDialog(props: {
  item: any;
  onSubmit: (value: number) => void;
  onClose: () => void;
}) {
  const [value, setValue] = useState<number>();

  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) {
          props.onClose();
        }
      }}
      className="max-w-[400px]"
    >
      <form
        onSubmit={(event) => {
          event.preventDefault();
          if (value !== undefined) props.onSubmit(value);
        }}
        className="flex flex-col items-center"
      >
        <p className="mb-2">
          <Trans>
            Manual override of the value of <b>{props.item.measurement_type}</b>
            , will be used in algorithms instead of{" "}
            <b>{props.item.data_source}</b> value.
          </Trans>
        </p>

        <NumberInput
          value={value}
          onChange={setValue}
          autofocus
          className="mb-2"
        />

        <Button type="submit">
          <Trans>Submit</Trans>
        </Button>
      </form>
    </Dialog>
  );
}
